export const USER_GROUPS = {
  CLIENT: 10,
  STAFF: 5
}
